import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import ListItem from '@material-ui/core/ListItem';
//import FlareIcon from '@material-ui/icons/Flare';
// import CallSplitIcon from '@material-ui/icons/CallSplit';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import { getChallengeTypes } from '../../common/challenges';
import styles from './Stop.module.scss';
import { getInternalBaseUrl } from '../../common/global';

export default class SparkStop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onDragStopStart = this.onDragStopStart.bind(this);
    this.onDragStopOver = this.onDragStopOver.bind(this);
    this.onDropStop = this.onDropStop.bind(this);
  }

  onClickBookingStop = () => {
    const { stop = {}, index } = this.props;
    stop.index = index;
    this.props.onSelectStopFunc(stop);
  };

  onDragStopStart = (e) => {
    const { stop = {} } = this.props;
    const { index = -1 } = stop;
    e.dataTransfer.setData('text/plain', index);

    e.stopPropagation();
  };

  onDragStopOver = (e) => {
    const { stop = {}, highlightDestinationFunc } = this.props;
    const { index = -1 } = stop;
    e.preventDefault();
    e.stopPropagation(); // Don't send it further
    highlightDestinationFunc(index);
  };

  // TODO: Test drag\drop as it has a slight change.
  onDropStop = (e) => {
    const { stop = {}, onSwapFunc } = this.props;
    const { index = -1 } = stop;
    const from = e.dataTransfer.getData('text');
    const to = index;
    onSwapFunc(from, to);

    e.stopPropagation();
  };

  render() {
    const { highlight, stop, index } = this.props;

    let borderLeftStyle = `3px solid transparent}`;
    const challengeTypes = getChallengeTypes();
    const typeObj = _.find(challengeTypes, { value: stop?.challenge?.type }) || {
      name: 'Misc Activity',
    };
    const typeString = typeObj.name;
    let gotoSparkUrl = getInternalBaseUrl().sparks + '?id=' + stop?.spark?.id;

    let borderColor = '#52A8EF';
    let borderStyle = 'none';
    let padding = '0px';
    
    if (highlight === index) {
      borderColor = '#52A8EF';
      borderStyle = 'dashed';
      padding = '5px';
    }

    return (
      <div
        className={styles.root}
        draggable
        onDragStart={this.onDragStopStart}
        onDragOver={this.onDragStopOver}
        onDrop={this.onDropStop}
      >
        <div
          className={styles.list}
          style={{
            borderColor: borderColor,
            borderStyle: borderStyle,
            padding: padding,
          }}
        >
      <ListItem >          
        <div className={styles.extraSmallColumn} style={{ width: ' 50px !important' }} 
          onClick={this.onClickBookingStop}>
          <SwapHorizIcon />
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyItems: 'flex-start',
            alignItems: 'center',
          }}
        >
          <div className={styles.largeColumn}>
            <Link
              to={gotoSparkUrl}
              target="_blank"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <span
                className={styles.boldFont}
                style={{
                  borderLeft: borderLeftStyle,
                  paddingLeft: '',
                }}
              >
                Step {this.props.stepIndex}
                &nbsp; - &nbsp;
                {stop?.spark?.name || 'Invalid Spark Object'}
              </span>
            </Link>
          </div>

          <div
            className={styles.extraLargeColumn}
            style={{
              padding: '10px',
            }}
          >
            {stop?.challenge?.name || 'No Challenge'}
          </div>
          <div className={styles.extraLargeColumn}>
            <span
              style={{
                backgroundColor: '#666',
                color: '#eee',
                padding: '6px 8px',
                textAlign: 'center',
                minWidth: '100px',
                display: 'inline-block',
                borderRadius: '18px',
              }}
            >
              {typeString}
            </span>
          </div>
          <div className={styles.smallColumn} style={{ display: 'flex' }}>
            &nbsp;
          </div>
          <div className={styles.extraLargeColumn}>&nbsp;</div>
          <div className={styles.extraLargeColumn}>&nbsp;</div>
          <div className={styles.extraSmallColumn} style={{ width: '30px !important' }}>
            &nbsp;
          </div>
        </div>       
      </ListItem>
      </div>
      </div>
    );
  }
}
